import UserSignUpEdit from "./userSignUpEdit";
import UserSignUpList from "./UserSignUpList";
import UserSignUpShow from "./UserSignUpShow";

export default {
    list: UserSignUpList,
    edit: UserSignUpEdit,
    show: UserSignUpShow
}